import useClusterConfig from "hooks/useClusterConfig";
const CONFIG_CLASS = "org.graylog2.configuration.MarkdownConfiguration";
const useMarkdownConfig = () => useClusterConfig(CONFIG_CLASS);
export default useMarkdownConfig;
